<template>
  <div class="container">
    <!-- 固定导航 -->
    <van-nav-bar fixed left-arrow @click-left="$router.back()" title="小智同学"></van-nav-bar>

    <!-- 聊天主体区域 -->
    <div class="chat-list" ref="refList">
      <!-- 左侧是机器人小智 -->
      <div class="chat-item"
      v-for="(item, index) in list"
      :key="index"
      :class="item.name==='xz' ? 'left' : 'right'"
      >
        <template v-if="item.name==='xz'">
            <van-image fit="cover" round src="https://img.yzcdn.cn/vant/cat.jpeg" />
            <div class="chat-pao">{{item.msg}}</div>
        </template>
        <template v-else>
            <div class="chat-pao">{{item.msg}}</div>
            <van-image  fit="cover" round :src="user.photo" />
        </template>
      </div>
    </div>

    <!-- 对话区域 -->
    <div class="reply-container van-hairline--top">
      <van-field v-model.trim="word" placeholder="说点什么...">
        <span  @click="send()" slot="button" style="font-size:12px;color:#999">提交</span>
      </van-field>
    </div>
  </div>
</template>

<script>
import { reqGetUserInfo } from '@/api/user.js'
export default {
  name: 'UserChat',
  data () {
    return {
      word: '',
      user: {},
      list: [], // 对话记录
      ws: null,
      isOpen: false
    }
  },
  created () {
    this.loadUserInfo()
    this.openWs()
  },
  methods: {
    send () {
      if (this.word === '') return
      if (this.isOpen) {
        this.ws.send(this.word)
        this.list.push({
          name: 'me',
          msg: this.word,
          timestamp: +new Date()
        })
        this.word = ''
      }
      console.log(this.word)
    },
    async loadUserInfo () {
      const res = await reqGetUserInfo()
      console.log(res)
      this.user = res.data.data
    },
    openWs () {
      this.ws = new WebSocket('wss://echo.websocket.org')
      this.ws.onopen = event => {
        this.isOpen = true
        this.list.push({
          name: 'xz',
          msg: '你好我是小智，我准备好了',
          timestamp: +new Date()
        })
      }
      // 接收消息 event中的data就是服务器发过来的消息
      this.ws.onmessage = event => {
        this.list.push({
          name: 'xz',
          msg: event.data,
          timestamp: +new Date()
        })
        // 需要等 dom 更新之后执行
        this.$nextTick(() => {
        //   console.log(this.$refs.refList.scrollHeight)
          this.$refs.refList.scrollTop = this.$refs.refList.scrollHeight
        })
      }
      //  关闭连接成功 wx.close()
      this.ws.onclose = function () {
        // 关闭连接成功
        this.isOpen = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  background:#fafafa;
  padding: 46px 0 50px 0;
  .chat-list {
    height: 100%;
    overflow-y: scroll;
    .chat-item{
      padding: 10px;
      .van-image{
        vertical-align: top;
        width: 40px;
        height: 40px;
      }
      .chat-pao{
        vertical-align: top;
        display: inline-block;
        min-width: 40px;
        max-width: 70%;
        min-height: 40px;
        line-height: 38px;
        border: 0.5px solid #c2d9ea;
        border-radius: 4px;
        position: relative;
        padding: 0 10px;
        background-color: #e0effb;
        word-break: break-all;
        font-size: 14px;
        color: #333;
        &::before{
          content: "";
          width: 10px;
          height: 10px;
          position: absolute;
          top: 12px;
          border-top:0.5px solid #c2d9ea;
          border-right:0.5px solid #c2d9ea;
          background: #e0effb;
        }
      }
    }
  }
}
.chat-item.right{
  text-align: right;
  .chat-pao{
    margin-left: 0;
    margin-right: 15px;
    &::before{
      right: -6px;
      transform: rotate(45deg);
    }
  }
}
.chat-item.left{
  text-align: left;
  .chat-pao{
    margin-left: 15px;
    margin-right: 0;
    &::before{
      left: -5px;
      transform: rotate(-135deg);
    }
  }
}
.reply-container {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 44px;
  width: 100%;
  background: #f5f5f5;
  z-index: 9999;
}
</style>
